import {FC} from 'react';

import {NavigationTabs} from '@mavismart_frontend/components/navigation_tabs';
import {DoorDetails} from '@mavismart_frontend/pages/tabs/door_details';
import {DoorInfo} from '@mavismart_frontend/pages/tabs/door_info';
import {DoorMessages} from '@mavismart_frontend/pages/tabs/door_messages';
import {DoorStatistics} from '@mavismart_frontend/pages/tabs/door_statistics';

interface DoorTabsProps {
  doorId: string;
  baseUrl: string;
}

export const DoorTabs: FC<DoorTabsProps> = props => {
  const {doorId, baseUrl} = props;

  return (
    <>
      <NavigationTabs
        tabs={[
          {
            path: `${baseUrl}/info`,
            label: 'info',
            view: <DoorInfo doorId={doorId} baseUrl={baseUrl} />,
            default: true,
          },
          {
            path: `${baseUrl}/statistics`,
            label: 'statistics',
            view: <DoorStatistics doorId={doorId} />,
          },
          {
            path: `${baseUrl}/messages`,
            label: 'messages',
            view: <DoorMessages baseUrl={`${baseUrl}/messages`} doorId={doorId} />,
          },
          {
            path: `${baseUrl}/details`,
            label: 'details',
            view: <DoorDetails baseUrl={`${baseUrl}/details`} doorId={doorId} />,
          },
        ]}
      />
    </>
  );
};

DoorTabs.displayName = 'DoorTabs';
